export default __webpack_public_path__ + "static/media/5H.04a38bb9.svg";